import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'

import { CapacityConflictGroupKind } from '../../types'

import styles from './CapacityConflictItemGroupHeader.module.scss'

const GroupLabelKeys: Record<CapacityConflictGroupKind, string> = {
  [CapacityConflictGroupKind.Choose]:
    'checkoutCapacityConflict.groupChooseWhatToKeep',
  [CapacityConflictGroupKind.Remove]:
    'checkoutCapacityConflict.groupWillBeRemoved',
}

type CapacityConflictItemGroupHeaderProps = {
  kind: CapacityConflictGroupKind
  count: number
}

export default function CapacityConflictItemGroupHeader({
  kind,
  count,
}: CapacityConflictItemGroupHeaderProps) {
  const { t } = useTranslation('common')

  return (
    <div
      className={clsx(styles.header, {
        [styles.remove]: kind === CapacityConflictGroupKind.Remove,
      })}
    >
      <span className={styles.label}>{t(GroupLabelKeys[kind])}</span>
      <span className={styles.count}>
        {t('checkoutCapacityConflict.blockingItemsCount', { count })}
      </span>
    </div>
  )
}
